import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const IconWrapper = memo(props => {
    return <FontAwesomeIcon {...props} />;
});
